import React, { useState } from 'react'
import LOCALES from './locales.js'

/**
 * Display a little warning depending on how many municipalities are counted
 * @param {{ locale: string | number; }} props
 * @param {{ date: string; }} props
 * @param {{ canton: string; }} props
 */
export const CountState = ({ locale, date, canton }) => {
  const [percentage, setPercentage] = useState(0)
  const fetchCount = canton => {
    const BASE_URL = process.env.NODE_ENV === 'production' ? 'https://atm.tamedia.ch' : 'http://localhost:5000'
    // const BASE_URL = 'https://atm.tamedia.ch'
    const API_ENDPOINT = '/api/vote/get_counted_municipalities'
    const endpoint = new URL(API_ENDPOINT, BASE_URL)
    endpoint.searchParams.append('date', date) // 20200927
    endpoint.searchParams.append('canton', canton)
    const url = endpoint

    return window
      .fetch(url.href, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      })
      .then(response => {
        if (response.ok) {
          return response.json()
        }
        throw new Error(response.status + ': ' + response.statusText)
      })
      .catch(error => {
        throw new Error(
          'Cannot fetch counted municipalities from server: ' + error.message
        )
      })
  }

  fetchCount(canton)
    .then(data => {
      if (data.perc !== undefined && data.perc >= 0 && data.perc <= 100) {
        setPercentage(data.perc)
      }
    })
    .catch(error => {
      console.error(
        'Error when fetching counted municipalities: ' + error.message
      )
      setPercentage(100)
    })

  let messagekey = 'warning_less_than_fifty_' + canton.toLowerCase()
  if (percentage > 50) {
    messagekey = 'warning_more_than_fifty_' + canton.toLowerCase()
  }

  return (
    <>
      {percentage < 100 && (
        <small>
          <b>{LOCALES.remark[locale]}</b>: {LOCALES[messagekey][locale]}
        </small>
      )}
    </>
  )
}
